<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-grid"/> {{ caption }}
      </slot>
    </CCardHeader>
    <CCardBody>
      <CDataTable
        :hover="hover"
        :striped="striped"
        :bordered="bordered"
        :small="small"
        :fixed="fixed"
        :items="items"
        :items-per-page="itemsPerPage"
        :dark="dark"
        pagination
      >

        <template #marke="{ item }">
          <td>
            {{ item.marke.name}}
          </td>
        </template>
        <template #shopwareID="{ item }">
          <td>
            <CBadge v-if="item.shopwareID == 'Keine'" color="danger">Noch keine</CBadge>
            <CBadge v-else color="success">{{ item.shopwareID }}</CBadge>
          </td>
        </template>
        <template #steuern="{ item }">
          <td>
            {{ item.steuern }} %
          </td>
        </template>
        <template #straßenpreis="{ item }">
          <td>
            {{ item.straßenpreis| currency }}
          </td>
        </template>
        <template #eigenerPreis="{ item }">
          <td>
            {{ item.eigenerPreis| currency }}
          </td>
        </template>
        <template #gewicht="{ item }">
          <td>
            {{ item.gewicht }} Kg
          </td>
        </template>
        <template #swImport="{ item }">
          <td>
            <CBadge v-if="item.swImport === false" color="warning">Noch nicht Importiert</CBadge>
            <CBadge v-else color="info">{{ item.swImport }}</CBadge>
          </td>
        </template>
      </CDataTable>
    </CCardBody>
  </CCard>
</template>

<script>
export default {
  name: 'Table',
  props: {
    items: Array,
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,
    itemsPerPage: Number
  }
}
</script>
